import { Button, Checkbox,Row, Space, Tooltip } from 'antd';
import Footer from '../../../../components/common/Footer';
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from '../../../../components/common/RightBar';
import FormAction from '../../../../components/common/FormAction';
import RightBarMethod from '../../../../components/common/RightBar/RightBarMethod';

const RentreminderRightBarData = [
  RightBarMethod("HELP TOPICS", "t1", <i className="fa-solid fa-circle-question"></i>, [
    RightBarMethod("Rent Reminders", "1", "", "", ""),
    RightBarMethod("Unpaid Charges Reminders", "2", "", "", ""),
  ]),

];

const RentReminder = () => {
  return (<>
    <div className="page-container">
      <div className="main-container">
        <PageHeading heading="Rent Reminders" />

        <h4>Bulk Enable/Disable Reminders</h4>

        {/* <SubHeading subHeading="Bulk Enable/Disable Reminders" /> */}

        <Row style={{ marginTop: 8 }}>

          <Space direction='vertical'>
            <p>Enable rent reminder emails for all tenants. Reminders will be sent 2 days before the 1st of the month.</p>

            <Tooltip title="You must have permissions to access all portfolios and property groups to enable reminders for everyone. ">
              <Button style={{ marginTop: '5px', color: 'gray', border: '1px solid gray' }} >Enable Reminders</Button>
            </Tooltip>


          </Space>

        </Row>

        <br />

        <Row>

          <Space direction='vertical'>
            <p>Disable rent reminder emails for all tenants.*</p>

            <Tooltip title="You must have permissions to access all portfolios and property groups to enable reminders for everyone. ">
              <Button style={{ marginTop: '5px', color: 'gray', border: '1px solid gray' }} >Disable Reminders</Button>
            </Tooltip>

          </Space>

        </Row>



        <br />

        <Row style={{ borderBottom: "1px solid var(--hr-color)", paddingBottom: 12 }}>

          <p >*Tenants who have opted themselves in or out of rent reminders through the online portal will not be affected.</p>


        </Row>


        <Row>

          <Space direction='vertical'>

            <h4>Unpaid Charges Reminders</h4>

            <Checkbox checked={true} disabled>Send a reminder to tenants who have unpaid charges before their grace period ends.</Checkbox>

          </Space>

        </Row>

        <br />

        <FormAction />

        <Footer />
      </div>
    </div>
    <div className="RightSidebar">
      <RightBar RightBarData={RentreminderRightBarData} />
    </div>
  </>
  )
}

export default RentReminder;